import { StyleSheet } from 'react-native';

import { pt } from '../common/utils';

export default StyleSheet.create({
    body: {
        height: '100%',
        flex: 1
    },
    s_container: {
        backgroundColor: '#f5f5f5',
        width: pt(375),
        flex: 1
    },
    scroll_content: {
        paddingLeft: pt(16),
        paddingRight: pt(11)
    },
    brief: {
        height: pt(151),
        backgroundColor: '#aaa'
    },
    brief_bg: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: pt(375),
        height: pt(151)
    },
    brief_wrap: {
        paddingHorizontal: pt(28),
        paddingTop: pt(14),
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    brief_info: {
        marginBottom: pt(12),
        flex: 1,
        justifyContent: 'flex-end',
        alignItems: 'flex-start'
    },
    mask: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.7)'
    },
    video_bg_wrap: {
        width: pt(95),
        height: pt(137),
        shadowColor: 'rgba(0,0,0,1)',
        shadowOffset: { width: 2, height: 2 },
        shadowRadius: 10,
        shadowOpacity: 0.4,
        elevation: 4,
        borderTopLeftRadius: pt(2),
        borderTopRightRadius: pt(2),
        overflow: 'hidden',
        justifyContent: 'center',
        alignItems: 'center'
    },
    video_bg: {
        width: pt(95),
        height: pt(137)
    },
    video_play: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: [{ translateX: -pt(15) }, { translateY: -pt(15) }],
        width: pt(30),
        height: pt(30),
        resizeMode: 'contain'
    },
    brief_name: {
        fontSize: pt(16),
        lineHeight: pt(22),
        fontFamily: 'PingFangSC-Regular',
        color: '#fff',
        backgroundColor: 'transparent',
        marginRight: pt(10)
    },
    brief_english_name: {
        fontSize: pt(10),
        lineHeight: pt(14),
        fontFamily: 'PingFangSC-Regular',
        color: '#fff',
        backgroundColor: 'transparent',
        marginBottom: pt(4)
    },
    brief_score: {
        marginBottom: pt(6),
        flexDirection: 'row',
        backgroundColor: 'transparent',
        alignItems: 'center'
    },
    brief_score_text: {
        color: '#FFD81E',
        lineHeight: pt(22),
        fontFamily: 'PingFangSC-Regular',
        backgroundColor: 'transparent',
        fontSize: pt(14)
    },
    brief_like: {
        flexDirection: 'row',
        marginBottom: pt(6)
    },
    brief_like_one: {
        color: '#FFD81E',
        fontSize: pt(14),
        backgroundColor: 'transparent',
        fontFamily: 'PingFangSC-Regular'
    },
    brief_like_two: {
        color: '#fff',
        backgroundColor: 'transparent',
        fontSize: pt(9)
    },
    brief_item: {
        color: '#fff',
        lineHeight: pt(17),
        fontFamily: 'PingFangSC-Regular',
        backgroundColor: 'transparent',
        fontSize: pt(11)
    },
    fns: {
        paddingVertical: pt(18),
        paddingHorizontal: pt(16),
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: '#fff'
    },
    fn: {
        height: pt(40),
        width: pt(164),
        backgroundColor: '#F5F7F8',
        borderRadius: pt(2),
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    fn_icon: {
        height: pt(16),
        width: pt(15),
        resizeMode: 'contain'
    },
    fn_text: {
        marginLeft: pt(4),
        color: '#898989',
        lineHeight: pt(20),
        fontFamily: 'PingFangSC-Regular',
        fontSize: pt(14)
    },
    evaluate: {
        width: '100%',
        paddingVertical: pt(10),
        paddingHorizontal: pt(15),
        borderRadius: pt(2),
        alignItems: 'center',
        backgroundColor: '#F5F7F8',
        flexDirection: 'row'
    },
    evaluate_label: {
        marginRight: pt(6),
        color: '#252525',
        fontSize: pt(14)
    },
    evaluate_score: {
        marginLeft: pt(6),
        color: '#FFD405',
        fontSize: pt(16)
    },
    intro: {
        paddingHorizontal: pt(16),
        backgroundColor: '#fff',
        paddingBottom: pt(18)
    },
    intro_text: {
        color: '#252525',
        lineHeight: pt(24),
        fontFamily: 'PingFangSC-Regular',
        fontSize: pt(13)
    },
    actors_wrap: {
        marginTop: pt(7),
        backgroundColor: '#fff',
        paddingBottom: pt(17)
    },
    actors_label: {
        marginTop: pt(12),
        marginBottom: pt(6),
        color: '#252525',
        paddingLeft: pt(16),
        lineHeight: pt(24),
        fontFamily: 'PingFangSC-Regular',
        fontSize: pt(14)
    },
    actors: {
        flexDirection: 'row',
        flexWrap: 'wrap'
    },
    actor: {
        marginRight: pt(5),
        width: pt(70)
    },
    actor_photo: {
        width: pt(70),
        height: pt(105),
        resizeMode: 'cover',
        borderRadius: pt(2)
    },
    actor_name: {
        marginTop: pt(6),
        color: '#252525',
        lineHeight: pt(15),
        fontFamily: 'PingFangSC-Regular',
        fontSize: pt(12)
    },
    actor_role: {
        color: '#898989',
        lineHeight: pt(15),
        fontFamily: 'PingFangSC-Regular',
        fontSize: pt(10)
    },
    popup_info_wrap: {
        position: 'absolute',
        top: 0,
        left: 0,
        // width: '100%',
        // height: '100%',
        right: 0,
        bottom: 0,
        paddingHorizontal: pt(10),
        justifyContent: 'center',
        zIndex: 1
        // alignItems: 'center'
    },
    popup_info: {
        width: '100%',
        backgroundColor: '#fff',
        borderRadius: pt(4),
        paddingTop: pt(28),
        paddingBottom: pt(31),
        paddingHorizontal: pt(22)
    },
    actor_info_name: {
        color: '#252525',
        lineHeight: pt(25),
        fontFamily: 'PingFangSC-Regular',
        fontSize: pt(18)
    },
    actor_info_alias: {
        color: '#666',
        lineHeight: pt(17),
        fontFamily: 'PingFangSC-Regular',
        fontSize: pt(12)
    },
    actor_info_intro: {
        marginTop: pt(11),
        color: '#666',
        lineHeight: pt(17),
        fontFamily: 'PingFangSC-Regular',
        fontSize: pt(12)
    },
    actor_info_more: {
        marginTop: pt(13),
        borderTopColor: 'rgba(0, 0, 0, 0.1)',
        borderTopWidth: pt(1),
        maxHeight: pt(400)
    },
    actor_info_more_text: {
        color: '#898989',
        lineHeight: pt(14),
        fontFamily: 'PingFangSC-Regular',
        fontSize: pt(10),
        marginTop: pt(8),
        marginBottom: pt(12)
    },
    actor_info_more_info: {
        flexDirection: 'row',
        marginBottom: pt(5)
    },
    actor_info_more_image: {
        width: pt(60),
        height: pt(88),
        marginRight: pt(17)
    },
    actor_info_more_info_image: {
        justifyContent: 'center'
    },
    actor_info_more_info_header: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    actor_info_more_info_name: {
        color: '#000',
        lineHeight: pt(20),
        fontFamily: 'PingFangSC-Regular',
        fontSize: pt(14),
        marginRight: pt(14)
    },
    label: {
        flexDirection: 'row',
        height: pt(15)
    },
    label_one: {
        backgroundColor: '#898989',
        justifyContent: 'center',
        alignItems: 'center',
        borderColor: '#898989',
        borderWidth: pt(1),
        padding: pt(2),
        borderTopLeftRadius: pt(2),
        borderBottomLeftRadius: pt(2)
    },
    label_one_text: {
        color: '#fff',
        fontSize: pt(11)
    },
    label_two: {
        backgroundColor: '#fff',
        borderColor: '#898989',
        borderWidth: pt(1),
        justifyContent: 'center',
        alignItems: 'center',
        padding: pt(2),
        borderTopRightRadius: pt(2),
        borderBottomRightRadius: pt(2)
    },
    label_two_text: {
        color: '#898989',
        fontSize: pt(11)
    },
    actor_info_more_info_look: {
        flexDirection: 'row',
        marginTop: pt(4)
    },
    actor_info_more_info_look_one: {
        color: '#FFAE18',
        fontSize: pt(14)
    },
    actor_info_more_info_look_two: {
        color: '#898989',
        fontSize: pt(10)
    },
    actor_info_more_info_actors: {
        color: '#252525',
        fontSize: pt(12),
        marginTop: pt(7)
    },
    actor_info_more_info_show: {
        color: '#898989',
        fontSize: pt(10),
        marginTop: pt(3)
    },
    popup_close: {
        marginTop: pt(13),
        width: pt(27),
        height: pt(27),
        resizeMode: 'contain',
        alignSelf: 'center',
        marginBottom: pt(50)
    },
    popup_info_title: {
        color: '#252525',
        fontSize: pt(20),
        lineHeight: pt(28),
        fontFamily: 'PingFangSC-Regular'
    },
    popup_info_rate_wrap: {
        height: pt(40),
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: pt(20)
    },
    popup_info_sub: {
        // marginTop: pt(9),
        // marginBottom: pt(24),
        color: '#666',
        fontSize: pt(14),
        letterSpacing: pt(3),
        lineHeight: pt(20),
        fontFamily: 'PingFangSC-Regular'
    },
    popup_info_rate: {
        // marginTop: pt(9),
        // marginBottom: pt(19),
        color: '#FF7910',
        fontSize: pt(30)
    },
    popup_info_rate_addition: {
        color: '#252525',
        fontSize: pt(14)
    },
    popup_info_submit_wrap: {
        height: pt(38),
        width: pt(130),
        marginTop: pt(19),
        borderRadius: pt(19),
        borderWidth: pt(1),
        borderColor: '#F0250F',
        justifyContent: 'center',
        alignItems: 'center'
    },
    popup_info_submit: {
        // lineHeight: pt(38),
        // textAlign: 'center',
        color: '#F0250F',
        fontSize: pt(18)
    },
    media_top: {
        marginTop: pt(7)
    },
    media_wrap: {
        backgroundColor: '#fff',
        paddingTop: pt(14)
    },
    pic_wrap: {
        backgroundColor: '#fff',
        paddingBottom: pt(22)
    },
    media_label: {
        color: '#252525',
        paddingLeft: pt(16),
        lineHeight: pt(24),
        fontFamily: 'PingFangSC-Regular',
        fontSize: pt(14)
    },
    videos_wrap: {
        paddingBottom: pt(12),
        paddingTop: pt(5)
    },
    media_video: {
        position: 'relative',
        width: pt(181),
        height: pt(109),
        borderRadius: pt(2),
        marginRight: pt(5),
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden'
    },
    media_video_bg: {
        width: pt(181),
        height: pt(109)
    },
    media_video_play: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: [{ translateX: -pt(15) }, { translateY: -pt(15) }],
        width: pt(30),
        height: pt(30),
        resizeMode: 'contain'
    },
    images_wrap: {
        paddingBottom: pt(12),
        paddingTop: pt(5)
    },
    media_image: {
        width: pt(212),
        height: pt(98),
        resizeMode: 'cover',
        borderRadius: pt(2),
        marginRight: pt(5)
    },
    box_office: {
        marginTop: pt(5),
        height: pt(77),
        flexDirection: 'row',
        paddingHorizontal: pt(16),
        backgroundColor: '#fff'
    },
    box_office_part: {
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        width: '100%'
    },
    box_office_value: {
        color: '#F56A00',
        fontSize: pt(20),
        lineHeight: pt(24),
        fontFamily: 'PingFangSC-Regular'
    },
    box_office_label: {
        color: '#898989',
        fontSize: pt(10),
        lineHeight: pt(14),
        fontFamily: 'PingFangSC-Regular'
    },
    footer: {
        height: pt(50),
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    pay: {
        color: '#fff',
        fontSize: pt(16),
        backgroundColor: 'transparent'
    },
    swiper_info: {
        width: '100%',
        paddingLeft: pt(8),
        paddingRight: pt(16),
        height: pt(40),
        marginBottom: pt(23),
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    swiper_info_page: {
        color: '#fff',
        lineHeight: pt(40),
        fontFamily: 'PingFangSC-Regular',
        fontSize: pt(20)
    },
    swiper_info_pages: {
        fontSize: pt(16)
    }
});
